export const WORKSPACE_NAME = 'Zessta Software Services';
